import { ReactNode, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { DotMatrix } from '@clickguard/design-system'

/** HubSpot's code/state belong to the opener, not Auth0's login transaction. */
export function HubSpotOAuthBoundary({ children }: { children: ReactNode }) {
	const { pathname } = useLocation()
	return /^\/oauth\/crm\/hubspot\/?$/.test(pathname) ? (
		<HubSpotOAuthPage />
	) : (
		<>{children}</>
	)
}

export function HubSpotOAuthPage() {
	const params = new URLSearchParams(window.location.search)
	const state = params.get('state')
	const code = params.get('code')
	const error = params.get('error')
	useEffect(() => {
		if (window.opener && state)
			window.opener.postMessage(
				{ type: 'cg-hubspot-callback', state, code, error },
				window.location.origin
			)
	}, [state, code, error])
	return (
		<div className="flex min-h-screen items-center justify-center">
			<div className="flex flex-col items-center gap-4">
				<DotMatrix label="Completing HubSpot connection" />
				<p>
					{window.opener
						? 'Completing your HubSpot connection…'
						: 'Return to Connections and start the HubSpot connection again.'}
				</p>
			</div>
		</div>
	)
}
